export default __webpack_public_path__ + "static/media/annex4.2dff18e6.png";